//
export const ENVIRONMENT_GLOBAL = {
  appStoreLink: 'https://itunes.apple.com/us/app/one-medical-mobile/id393507802?mt=8',
  appSync: {
    apiUrl: 'https://eyyrallbu5ende7evmle6nurnm.appsync-api.us-east-1.amazonaws.com/graphql',
    region: 'us-east-1',
    enabled: true,
  },
  contactSupportLink: 'https://www.onemedical.com/contact-us',
  devRoutes: false,
  enableProdMode: false,
  googlePlayLink: 'https://play.google.com/store/apps/details?id=com.onemedical.android&hl=en',
  googlePlacesKey: 'AIzaSyB65GUfpcQKPvKkn2rXlnP8H9HciawCVHA',
  googleTagManagerId: 'GTM-WSN7TRS',
  googleConversionId: 1039580055,
  hintPortalUrl: 'https://onemedical.hint.com/login/request',
  launchDarklyClientId: '6018851e17303e09d8153a73',
  marketingSite: 'https://mktg-stage.onemedical.com',
  mixpanelToken: '44008e1ef10bb5ecc7b4f967257c824d',
  mixpanelDebug: false,
  mixpanelCrossDomain: false,
  oneMedicalPhone: '415-291-0480',
  opsUrl: 'https://staging.patientops.com',
  pusherKey: '5422148b626236f6bff3',
  newRecaptchaSiteKey: '6LfOAAEqAAAAAOBjja3YkPr2sld9NEi0sHmUnHJ6',
  sentry: {
    enabled: false,
    dsn: 'https://94fb2cb964527591835f763ad4493a4f@o4506221115408384.ingest.us.sentry.io/4506855554154496',
    environment: '',
  },
  stripePublishableKey:
    'pk_test_517WAN8I6Upoy4vYdDY4YyNaM2bQHskzSWEzGUnoNNCJaLC15PQWK40pTvmerXur4MYXMVMCsAoi0yQPCBsAXrLNF00DrMRauN5',
  topLevelDomain: '',
  typeaheadDataLoggingUrl: 'https://any-ac-ml-qualification.app.1life.com/data-logging/member',
  typeaheadSearchUrl: 'https://any-ac-ml-qualification.app.1life.com/autocomplete/member',
  typeaheadTestingMode: true,
  amazonUrls: {
    purchaseMembership: 'https://health.amazon.com/prime',
    manageMembership: 'https://health.amazon.com/prime/onemedical/settings',
    primeCheckoutPage: 'https://health.amazon.com/prime/onemedical/checkout',
    primeCheckoutUpgradePage: 'https://health.amazon.com/prime/onemedical/checkout/upgrade',
    enterpriseRegistrationRedirect: 'https://health.amazon.com/onemedical/enroll/enterprise',
  },
  lwaClientId: '',
  lwaAuthorizationUrl: 'https://health.amazon.com/ap/oa',
  lwaTokenEndpoint: 'https://api.amazon.com/auth/o2/token',
  rum: {
    applicationId: '382ae629-a51e-4962-bd3c-08be4459a307',
    enabled: true,
    endpoint: 'https://rum-proxy.us-west-2.beta.patient-ui.onemedical.amazon.dev',
  },
};
